import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=ba035d42&scoped=true"
import script from "./Verify.vue?vue&type=script&lang=ts"
export * from "./Verify.vue?vue&type=script&lang=ts"
import style0 from "./Verify.vue?vue&type=style&index=0&id=ba035d42&prod&lang=scss&scoped=true"
import style1 from "./Verify.vue?vue&type=style&index=1&id=ba035d42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba035d42",
  null
  
)

export default component.exports